import { useAccount, useReadContracts } from 'wagmi';
import { erc20Abi } from 'viem';
import { useAuth } from 'src/libs/rainbow';
import { IUserInfo } from 'src/store/reducers/user';
import { useAppSelector } from 'src/store';

interface Props {
  tokenAddresses: `0x${string}`[];
}

export function useMultipleErc20Balances({ tokenAddresses }: Props) {
  const { address: userAddress } = useAccount();
  const { isAuthenticated } = useAuth();
  const userInfo: IUserInfo = useAppSelector((state) => state.user);

  const walletAddress = userAddress ?? userInfo.walletAddress;
  const contracts = tokenAddresses.map((token) => ({
    abi: erc20Abi,
    address: token,
    functionName: 'balanceOf',
    args: [walletAddress],
  }));

  const result = useReadContracts({
    contracts,
    allowFailure: true,
    query: {
      enabled: Boolean(userAddress) && isAuthenticated,
    },
  });

  return result;
}